import { useTranslation } from 'react-i18next';
import { filesize } from 'filesize';

export default function useFilesize() {
  const { t } = useTranslation();
  const symbols = t('filesize:symbols:jedec:bytes', {
    returnObjects: true,
  }) as Record<string, string>;
  const locale = t('translation:locale') as string;

  return (size: number) =>
    filesize(size, { locale, standard: 'jedec', symbols });
}
